export class SousBien {
    id: number = 0;
    name: string = '';
    nameArabe: string = '';
    nameAnglais: string = '';
    description: string = '';
    descriptionArabe: string = '';
    descriptionAnglais: string = '';
    adressmap: string = '';
    website: string = '';
    category: string = '';
    image_url: string = '';
    prix: string = '';
    imagesList: string[] = [];
    role: string = '';
    displayOrder: number = 0;
    bienId: number = 0;
}